import './src/css/index.css';

window.onload = () => {
    if (!localStorage.getItem(`cookie-bar-visible`)) {
        localStorage.setItem(`cookie-bar-visible`, `true`);
    }
};
